import { memo, useState, useCallback, useEffect, useRef } from 'react';
import { Text, Input, Button, Link, Icon, useTheme } from 'hoi-poi-ui-next';
import * as Tracking from 'utils/tracking';
import { sendVerifyCode, verifyCode } from 'services/ExternalService';

const SignupEmailVerification = memo(({ t, onStep, active, data }) => {
    const theme = useTheme();
    const inputRef = useRef();
    const [code, setCode] = useState();
    const [error, setError] = useState();

    const onConfirm = useCallback(
        (e) => {
            e?.preventDefault?.();
            let newError;

            // Required
            if (!code) newError = t('label_field_required');

            if (newError) {
                setError(newError);
            } else {
                verifyCode({ email: data.current.email, code: code?.trim() })
                    .then(() => {
                        setError(null);
                        onStep(1, { verified: true });
                    })
                    .catch((e) => {
                        console.error(e);
                        if (e?.response?.status === 400) {
                            setError(t('label_incorrect_code'));
                        } else {
                            onStep(3);
                        }
                    });
            }
        },
        [code, data, onStep, t],
    );

    const onPrevious = useCallback(() => {
        onStep(-1);
    }, [onStep]);

    useEffect(() => {
        if (!active) return;
        setError();
        setCode();
        inputRef.current.focus();
        Tracking.logEvent({
            event: 'signup',
            functionality: 'userValidation',
            platform: 'web',
        });

        sendVerifyCode(data.current.email).catch((e) => {
            console.error(e);
            onStep(3);
        });
    }, [active, data, onStep]);

    return (
        <div className="signup__email-verification">
            <Text type="h6" isHighlighted>
                {t('label_email_verification')}
            </Text>
            <Text>{t('label_email_verification_description', [data.current.email])}</Text>
            <form onSubmit={onConfirm}>
                <Input
                    ref={inputRef}
                    label={t('label_verification_code')}
                    onChange={setCode}
                    onEnter={onConfirm}
                    value={code}
                    type="text"
                    isRequired
                    isFullWidth
                    error={error}
                />
            </form>
            <footer>
                <Link className="signup__link" variation="primary" onClick={onPrevious}>
                    <Icon name="chevronLeft" color={theme.colors.orange500} />
                    {t('label_previous')}
                </Link>
                <Button size="big" onClick={onConfirm}>
                    {t('label_confirm')}
                </Button>
            </footer>
        </div>
    );
});

export default SignupEmailVerification;
